import React from 'react'
import Helpline from '../components/hotline/Helpline'
import Hero from '../components/hotline/Hero'
import Info from '../components/hotline/Info'

function CrisisHotline() {
  return (
    <div className='fontt'>
      <Hero/>
      {/* <Info/> */}
      <Helpline/>
    </div>
  )
}

export default CrisisHotline
